import en from './en'
import ko from './ko'
import ms from './ms'
import th from './th'
import vi from './vi'
import zh from './zh'
import _in from './in'
export default { en, ko, ms, th, vi, zh, in: _in }
